import React from 'react';
import { Form } from 'react-bootstrap';

const MonthDaysSelector = ({ selectedMonthDays, setSelectedMonthDays }) => {
  const handleMonthDayChange = (idx) => (e) => {
    const checked = e.target.checked;
    let newSelected = checked
      ? [...selectedMonthDays, idx + 1]
      : selectedMonthDays.filter((d) => d !== idx + 1);
    newSelected.sort((a, b) => a - b);
    setSelectedMonthDays(newSelected);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <Form.Group className="mb-3 w-100">
        <div className="d-flex flex-row mb-2 w-100 justify-content-between">
          <Form.Label className="fw-bold text-white mb-2"></Form.Label>
          <div
            className="d-grid"
            style={{ gridTemplateColumns: 'repeat(7, 1fr)', gap: '0.5rem', maxWidth: 600 }}
          >
            {[
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
              25, 26, 27, 28, 29, 30, 31,
            ].map((month, idx) => {
              const isChecked = selectedMonthDays.includes(idx + 1);
              return (
                <Form.Check
                  key={month}
                  type="checkbox"
                  id={`month-${month}`}
                  label={month}
                  className="text-white me-3"
                  checked={isChecked}
                  onChange={handleMonthDayChange(idx)}
                />
              );
            })}
          </div>
        </div>
      </Form.Group>
    </div>
  );
};

export default MonthDaysSelector;
